import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import Table from "../../components/Table";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../pages/layout/Layout";
import {
  viewFeedbacks,
  deleteFeedbacks,
} from "../../../states/actions/feedbackAction";
import Loading from "../loading/Loading";

const ViewComment = () => {
  // dispatch
  const dispatch = useDispatch();

  const feedback = useSelector((state) => state.feedback);
  // use effect
  useEffect(() => {
    dispatch(viewFeedbacks());
  }, []);

  function handleRemoveFeedback(data) {
    if (
      window.confirm(
        "Data deleted permantly. Are you sure to delete completely!",
      )
    ) {
      dispatch(deleteFeedbacks(data.feedbackId));
    }
    setTimeout(function () {
      dispatch(viewFeedbacks());
    }, 500);
  }

  return (
    <Layout title={"Message"}>
      <Box sx={{ pt: "80px", pb: "20px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <Typography variant="h6">Messages</Typography>
        </Box>

        {feedback?.feedback ? (
          <Table
            data={feedback?.feedback}
            fields={feedbackColumns}
            numberOfRows={feedback?.feedback?.length}
            enableTopToolBar={true}
            enableBottomToolBar={true}
            enablePagination={true}
            enableRowSelection={true}
            enableColumnFilters={true}
            enableEditing={true}
            enableColumnDragging={true}
            showPreview={true}
            deleteFunction={handleRemoveFeedback}
          />
        ) : (
          <Loading />
        )}
      </Box>
    </Layout>
  );
};

export default ViewComment;

export const feedbackColumns = [
  {
    accessorKey: "name", //access nested data with dot notation
    header: "Name",
  },
  {
    accessorKey: "phone", //access nested data with dot notation
    header: "Phone no.",
  },
  {
    accessorKey: "subject", //access nested data with dot notation
    header: "Subject",
  },

  {
    accessorKey: "message", //access nested data with dot notation
    header: "Message",
  },
];
